import { PaymentConcept } from '@/types'
import { RootState } from '../../app/store'

export const selectPayments = (state: RootState) => state.payments.payments

export const selectPaymentsLoading = (state: RootState) => state.payments.isLoading

export const selectPaymentsError = (state: RootState) => state.payments.error

export const selectPaymentById = (paymentId: string) => (state: RootState) =>
  state.payments.payments.find(payment => payment.id === paymentId)

export const selectPendingPayments = (state: RootState) =>
  state.payments.payments.filter(payment => payment.status === 'pending')

export const selectPaymentItems = (state: RootState) : PaymentConcept[] => state.payments.paymentConcepts

export const selectPaymentFilters = (state: RootState) => state.payments.filters;

export const selectLastFetch = (state: RootState) => state.payments.lastFetch

export const selectPagination = (state: RootState) => state.payments.pagination;

export const selectHasActiveFilters = (state: RootState) => {
  const filters = state.payments.filters
  return !!(
    filters.dateRange.start ||
    filters.dateRange.end ||
    filters.status ||
    filters.userId ||
    filters.userName||
    filters.paymentItem
  )
}

export const selectStudentPurchases = (state: RootState) => state.payments.studentPurchases

export const selectStudentPurchasesLoading = (state: RootState) => state.payments.studentPurchasesLoading

export const selectStudentPurchasesError = (state: RootState) => state.payments.studentPurchasesError

export const selectUserPurchases = (state: RootState) => state.payments.userPurchases

export const selectUserPurchasesLoading = (state: RootState) => state.payments.userPurchasesLoading

export const selectUserPurchasesError = (state: RootState) => state.payments.userPurchasesError